import { useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { selectCurrentUserRole } from '../features/auth/authSlice';
import { getNavigatePage } from '../hooks/useNavigatePage';

export default function Unauthorized() {

    const navigate = useNavigate();
    const location = useLocation();
    const userRole = (useSelector(selectCurrentUserRole) ?? '').toLowerCase();
    const redirectPath = getNavigatePage(userRole || "");

    const handleGoBack = () => {
        if (location.state?.from) {
            navigate(location.state.from, { replace: true });
        } else {
            navigate(redirectPath, { replace: true });
        }
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 text-center px-4">
            <div className="bg-white border rounded-2xl p-10 max-w-md w-full">
                <h1 className="text-2xl font-bold text-gray-800 mb-2">Unauthorized Access</h1>
                <p className="text-gray-600 mb-6">
                    Sorry, you don’t have permission to view this page.
                </p>
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                <button
                    onClick={handleGoBack}
                    className="px-6 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300 transition-all"
                >
                    Go Back
                </button>
                <Link
                    to="/login-staff"
                    className="px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-all"
                >
                    Login
                </Link>
                </div>
            </div>
            <p className="mt-8 text-gray-400 text-sm">
                &copy; {new Date().getFullYear()} Phillife. All rights reserved.
            </p>
        </div>
    )
}
